/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import EcommerceAgent from '../components/ecommerceAgent';

function ProductShoppingAgent() {
  return (
    <div className="main">
      <Header />
      <EcommerceAgent />
      <Footer />
    </div>
  );
}

export default ProductShoppingAgent;
